export const NO_CONTEXT_VALUE_ERROR = (contextName: string, hookName: string) =>
  `${contextName} value is undefined! Component beyond context provider but using ${hookName} hook!`;
